import React, {useEffect, useRef} from "react";


export default function Dropdown({data, setValue, setOpen}) {

    const dropdownRef = useRef(null);

    function selection(props) {
        setValue({
            id: props._id,
            name: props.name
        })
        setOpen(false)
    }

    useEffect(() => {

        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [dropdownRef]);

    return (

        <div className="w-full absolute" ref={dropdownRef}>
            <div className="bg-[#D9D9D9] flex flex-col py-2 gap-3 rounded-lg">
                <input
                    type="text"
                    className=" w-[90%] px-5 bg-transparent placeholder:text-[12px]"
                    placeholder="searching ..."
                />

                <div className="pr-1 w-full">
                    <ul className="h-32  overflow-auto scrollbar ">
                        {data.map((item) => (
                            <li className="hover:cursor-pointer text-left pl-5 rounded-lg mr-2 hover:text-white hover:bg-buttonColor-shade4 duration-300 hover:transition-xl"
                                key={item._id}
                                onClick={() => selection(item)}
                            >
                                {item.name}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

        </div>
    );
}